import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class SentinelOne extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M10.382,19.342V0h3.24V19.342ZM14.391,24V3.863a8.006,8.006,0,0,1,3.223,1.429V22.01ZM6.385,22.01V5.292A8.006,8.006,0,0,1,9.608,3.863V24ZM18.4.951S21.618,4.875,21.618,7.7v9.768A3.82,3.82,0,0,1,19.9,20.72l-1.5.931ZM2.382,17.464V7.7C2.382,4.875,5.605.951,5.605.951v20.7L4.1,20.72A3.819,3.819,0,0,1,2.382,17.464Z" />
      </svg>
    );
  }
}

export default SentinelOne;
